// extracted by mini-css-extract-plugin
export default {"promoBanner":"bm_gZ","visible":"bm_g0","hidden":"bm_fV","promoText":"bm_g1","visitButton":"bm_g2","closeIcon":"bm_g3"};